import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  HeaderContainer,
  Logo,
  Nav,
  NavItem,
  ButtonsContainer,
  Button,
  LoginButton,
  ButtonText,
  ButtonIcon,
  MenuToggle,
  MobileMenuOverlay,
  MobileMenuContainer,
  MobileMenuHeader,
  MobileMenuLogo,
  MobileMenuActions,
  SearchButton,
  CloseButton,
  MobileNavItems,
  MobileNavItem,
  MobileButtonsContainer,
  MobileButton,
  MobileLoginButton,
  MobileMenuContent
} from './styles';
import icon1 from '../../../assets/images/icon1.webp';
import icon2White from '../../../assets/images/icon2.webp'; // Ícone de login branco
import logoImageWhite from '../../../assets/images/logo.png'; // Logo branca
import { FaSearch, FaTimes, FaBars } from 'react-icons/fa';
import { Helmet } from 'react-helmet-async';
import { trackFacebookEvent } from '../../../utils/metaPixels';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomolog = process.env.REACT_APP_BLOCK_INDEXING === 'true'; 


  const isActive = (path) => {
    return location.pathname === path ||
      (location.pathname === '/' && path === '/quienes-somos');
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    if (!mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  };

  const trackTalkToAdvisor = (channel = 'whatsapp') => {
    trackFacebookEvent({
      event: 'Contact',
      content_name: 'Habla con un asesor',
      channel,
      page: location.pathname
    });
  };



  return (
    <>

      {isHomolog && (
        <Helmet>
          {/* Garante que NENHUMA página neste ambiente será indexada */}
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
      )}

      <HeaderContainer>
        <Logo to="/">
          <img src={logoImageWhite} alt="Floqss" />
        </Logo>

        <Nav>
          <NavItem to="/" active={isActive('/quienes-somos').toString()}>Floqss Es</NavItem>
          <NavItem to={process.env.REACT_APP_URL_MARKETPLACE + "/marketplace/"} target='_blank'>Cursos disponibles</NavItem>
          <NavItem to="/seja-produtor" active={isActive('/seja-produtor').toString()}>Vende en FLOQSS</NavItem>
          <NavItem
            as="a"
            href="https://api.whatsapp.com/send/?phone=573042041209&text=%C2%A1S%C3%A9+el+primero+en+vender+con+Floqss%21+Hablemos+ahora&type=phone_number&app_absent=0"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackTalkToAdvisor('whatsapp')}
          >
            Habla con un asesor
          </NavItem>
        </Nav>

        <ButtonsContainer>
          <Button
            primary
            as="a"
            href={`${process.env.REACT_APP_API_URL}/floqss/#/dashboard`}
          >
            <ButtonText>Ingresar</ButtonText>
            <ButtonIcon>
              <img src={icon1} alt="Ingresar" />
            </ButtonIcon>
          </Button>
          <LoginButton
            as="a"
            href={`${process.env.REACT_APP_API_URL}/floqss/#/cadastrar-usuario?perfil=P`}
          >
            <ButtonText>Crear cuenta</ButtonText>
            <ButtonIcon>
              <img src={icon2White} alt="Crear cuenta" />
            </ButtonIcon>
          </LoginButton>
        </ButtonsContainer>

        <MenuToggle onClick={toggleMobileMenu}>
          <FaBars />
        </MenuToggle>
      </HeaderContainer>

      {/* Menu Mobile */}
      <MobileMenuOverlay isOpen={mobileMenuOpen} onClick={toggleMobileMenu} />
      <MobileMenuContainer isOpen={mobileMenuOpen}>
        <MobileMenuHeader>
          <MobileMenuLogo>
            <img src={logoImageWhite} alt="Floqss" />
          </MobileMenuLogo>
          <MobileMenuActions>
            <SearchButton>
              <FaSearch />
            </SearchButton>
            <CloseButton onClick={toggleMobileMenu}>
              <FaTimes />
            </CloseButton>
          </MobileMenuActions>
        </MobileMenuHeader>

        <MobileMenuContent>
          <MobileNavItems>
            <MobileNavItem to="/" active={isActive('/quienes-somos').toString()}>Floqss Es</MobileNavItem>
            <MobileNavItem as="a" href={`${process.env.REACT_APP_URL_MARKETPLACE}/marketplace/`} target="_blank" rel="noopener noreferrer">Cursos disponibles</MobileNavItem>
            <MobileNavItem to="/seja-produtor" active={isActive('/seja-produtor').toString()}>Vende en FLOQSS</MobileNavItem>
            <MobileNavItem
              as="a"
              href="https://api.whatsapp.com/send/?phone=573042041209&text=%C2%A1S%C3%A9+el+primero+en+vender+con+Floqss%21+Hablemos+ahora&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
              active={isActive('/fale-com-atendente').toString()}
              onClick={() => trackTalkToAdvisor('whatsapp')}
            >
              Habla con un asesor
            </MobileNavItem>
          </MobileNavItems>

          <MobileButtonsContainer>
            <MobileButton
              primary
              as="a"
              href={`${process.env.REACT_APP_API_URL}/floqss/#/login`}
            >
              Ingresar
            </MobileButton>
            <MobileLoginButton
              as="a"
              href={`${process.env.REACT_APP_API_URL}/floqss/#/cadastrar-usuario`}
            >
              Crear cuenta
            </MobileLoginButton>
          </MobileButtonsContainer>
        </MobileMenuContent>
      </MobileMenuContainer>
    </>
  );
};

export default Header;